var map = {
	"./001-A.svg": 423,
	"./002-b.svg": 424,
	"./003-c.svg": 425,
	"./004-d.svg": 426,
	"./005-e.svg": 427,
	"./006-f.svg": 428,
	"./007-g.svg": 429,
	"./008-h.svg": 430,
	"./009-I.svg": 431,
	"./010-j.svg": 432,
	"./011-k.svg": 433,
	"./012-l.svg": 434,
	"./013-m.svg": 435,
	"./014-n.svg": 436,
	"./015-o.svg": 437,
	"./016-p.svg": 438,
	"./017-q.svg": 439,
	"./018-r.svg": 440,
	"./019-s.svg": 441,
	"./020-t.svg": 442,
	"./021-u.svg": 443,
	"./022-v.svg": 444,
	"./023-w.svg": 445,
	"./024-x.svg": 446,
	"./025-y.svg": 447,
	"./026-z.svg": 448,
	"./027-0.svg": 449,
	"./027-one.svg": 450,
	"./028-1.svg": 451,
	"./028-zero.svg": 452,
	"./029-2.svg": 453,
	"./029-two.svg": 454,
	"./030-3.svg": 455,
	"./030-three.svg": 456,
	"./031-4.svg": 457,
	"./031-four.svg": 458,
	"./032-5.svg": 459,
	"./032-five.svg": 460,
	"./033-6.svg": 461,
	"./033-six.svg": 462,
	"./034-7.svg": 463,
	"./034-seven.svg": 464,
	"./035-8.svg": 465,
	"./035-eight.svg": 466,
	"./036-9.svg": 467,
	"./036-nine.svg": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8120;